import { gql } from "@apollo/client";

const GLOSSARY_QUERY = gql`
  query GlossaryQuery($siteHandle: [String]) {
    glossary: entries(section: "glossary", site: $siteHandle) {
      ... on glossaryTerm_Entry {
        id
        siteHandle
        title
        definition {
          rawHtml
        }
      }
    }
  }
`;

export default GLOSSARY_QUERY;
